<template>
  <div>
    <ContentHeader />

    <div class="content-container" v-loading="formLoading">
      <el-row class="form-item">
        <el-col :span="2">收货地址</el-col>
        <el-col :span="10">
          <el-form
            ref="addressForm"
            :model="addressInfo"
            :rules="addressRules"
            label-width="130px"
            size="small"
            class="address-form"
          >
            <el-form-item v-if="orderRecvList.length" label="选择收货地址">
              <el-select
                v-model="selsectAddress"
                filterable
                clearable
                placeholder="请选择收货地址"
                style="width: 100%;"
              >
                <el-option
                  v-for="(item, index) in addressList"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="业务员联系人" prop="receivePerson">
              <el-input
                v-model="addressInfo.receivePerson"
                placeholder="请输入业务员联系人（必填）"
              />
            </el-form-item>
            <el-form-item label="业务员联系手机" prop="receivePhone">
              <el-input
                v-model="addressInfo.receivePhone"
                maxlength="11"
                placeholder="请输入业务员联系手机（必填）"
              />
            </el-form-item>
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input
                v-model="addressInfo.contactPhone"
                maxlength="11"
                placeholder="请输入联系电话"
              />
            </el-form-item>
            <el-form-item label="地区" prop="areaData">
              <el-cascader
                v-model="addressInfo.areaData"
                :options="areaOptions"
                :props="{ expandTrigger: 'hover' }"
                clearable
              />
            </el-form-item>
            <el-form-item label="详细地址" prop="detailAddress">
              <el-input
                v-model="addressInfo.detailAddress"
                class="long-item"
                placeholder="请输入详细地址（必填），请确保与售点地址一致"
              />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <el-row class="form-item">
        <el-col>领用明细</el-col>
        <el-table :data="freezerInfo" class="order-data-table">
          <el-table-column label="图片" width="100">
            <template slot-scope="scope">
              <div class="item-image">
                <img :src="getImageUrl(scope.row)" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="名称" label-class-name="cell-left">
            <template slot-scope="scope">
              <div class="item-name">{{ scope.row.itemName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="品牌">
            <template slot-scope="scope">{{ scope.row.itemBrandList[0].abiBrandName }}</template>
          </el-table-column>
          <el-table-column label="领用数量">
            <el-input-number value=1 size="mini" :min="1" disabled />
          </el-table-column>
        </el-table>
      </el-row>

      <el-row class="form-item">
        <el-col :span="2">售点信息</el-col>
        <el-col :span="22" class="sfa-form">
          <el-form
            ref="sfaForm"
            :model="sfaInfo"
            :rules="sfaRules"
            label-width="120px"
            size="small"
            class="sfa-form"
          >
            <el-form-item label="售点编码" prop="sfaCode">
              <el-input v-model="sfaInfo.sfaCode" placeholder="请输入售点编码（必填）" @input="sfaInput">
                <i slot="suffix" v-if="sfaCheck.show && sfaCheck.success" class="el-input__icon el-icon-success" style="color: #21BA45"></i>
                <i slot="suffix" v-if="sfaCheck.show && !sfaCheck.success" class="el-input__icon el-icon-error" style="color: #C8102D"></i>
              </el-input>
              <el-button class="btn-blue" @click="checkSfaCode()" size="small" :loading="loading">点击验证</el-button>
              <span v-if="sfaInfo.sfaAddressName" class="sfa-address-name">
                售点名称：
                <b>{{ sfaInfo.sfaAddressName }}</b>
              </span>
              <span v-if="sfaInfo.sfaAddressName" class="sfa-address-name">
                售点地址：
                <b>{{ sfaInfo.sfaAddress }}</b>
              </span>
            </el-form-item>
            <el-form-item label="售点联系人" prop="sfaContactPerson">
              <el-input v-model="sfaInfo.sfaContactPerson" placeholder="请输入售点联系人（必填）" />
            </el-form-item>
            <el-form-item label="售点联系电话" prop="sfaContactPhone">
              <el-input v-model="sfaInfo.sfaContactPhone" maxlength="11" placeholder="请输入售点联系电话（必填）" />
              <span class="validate_tip">签收验证码接收号码</span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <el-row class="form-item">
        <el-col :span="2">订单备注</el-col>
        <el-col :span="22">
          <el-input type="textarea" rows="3" resize="none" :maxlength="255" placeholder="最多可输入255个字符" v-model="detailInfo.orderRemark"></el-input>
        </el-col>
      </el-row>

      <el-row class="form-item order-price">
        <el-col :span="10">订单明细</el-col>
        <el-col :span="10" class="price-row">
          <div>商品件数：1件</div>
          <div>
            扣除配额：
            <span style="color: #db2828">1件</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="price-box">
            <div>当前可使用预算</div>
            <div style="font-weight: bold">{{ quotaInfo.availableQuota }}件</div>
          </div>
        </el-col>
      </el-row>

      <div class="submit-btn">
        <el-button class="btn-red" @click="handleSubmit">+ 提交订单</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
import formValidators from '@/utils/formValidators'
import { validateMobile } from '@/utils/validate'
import { commonUtils } from '@/utils/common'
import { mapState } from 'vuex'
import freezerApi from '@/api/freezer'
export default {
  name: 'freezer-order',
  components: {
    ContentHeader
  },
  data () {
    const validateArea = (rule, value, callback) => {
      if (!value || value.length !== 3 || !value[0] || !value[1] || !value[2]) {
        callback(new Error('请选择地区信息'))
      } else {
        callback()
      }
    }
    return {
      freezerInfo: [],
      quotaInfo: {},
      formLoading: false,
      sfaCheck: {
        show: false,
        success: false
      },
      selsectAddress: '',
      addressInfo: {
        receivePerson: '',
        receivePhone: '',
        contactPhone: '',
        provinceId: '',
        cityId: '',
        countyId: '',
        detailAddress: '',
        areaData: []
      },
      addressList: [],
      orderRecvList: [],
      addressRules: {
        receivePerson: [
          { required: true, message: '请输入联系人', trigger: 'change' }
        ],
        receivePhone: [
          { required: true, message: '请输入联系手机', trigger: 'change' },
          { validator: formValidators.checkMobile, message: '请输入正确的手机号', trigger: 'change' }
        ],
        contactPhone: [
          { required: false, trigger: 'change' },
          { validator: formValidators.checkMobile, message: '请输入正确的手机号', trigger: 'change' }
        ],
        areaData: [
          { required: true, message: '请设置地区信息', trigger: 'change' },
          { validator: validateArea, trigger: 'change' }
        ],
        detailAddress: [
          { required: true, message: '请输入详细地址', trigger: 'change' }
        ]
      },
      sfaRules: {
        sfaCode: [
          { required: true, message: '请输入售点编码', trigger: 'change' }
        ],
        sfaContactPerson: [
          { required: true, message: '请输入售点联系人', trigger: 'change' }
        ],
        sfaContactPhone: [
          { required: true, message: '请输入售点联系电话', trigger: 'change' },
          { validator: formValidators.checkMobile, trigger: 'change' }
        ]
      },
      sfaInfo: {
        sfaCode: '',
        sfaAddressName: '',
        sfaAddress: '',
        sfaContactPerson: '',
        sfaContactPhone: ''
      },
      detailInfo: {
        orderType: '01',
        orderRemark: '',
        receivePerson: '',
        receivePhone: '',
        provinceId: '',
        cityId: '',
        countyId: '',
        detailAddress: '',
        sfaCode: '',
        sfaContactPerson: '',
        sfaContactPhone: ''
      },
      quotaId: '',
      itemId: '',
      itemCode: '',
      itemQuantity: 1,
      orderForm: {
        detailList: [],
        quotaOrder: {
          quotaId: '',
          itemId: '',
          itemCode: '',
          itemQuantity: 1
        }
      },
      loading: false
    }
  },
  computed: {
    ...mapState({
      areaOptions: state => state.base.areaData
    })
  },
  watch: {
    selsectAddress (val) {
      let flag = false
      for (let i = 0; i < this.orderRecvList.length; i++) {
        if (val === this.orderRecvList[i].orderId) {
          this.addressInfo = Object.assign({}, this.addressInfo, {
            receivePerson: this.orderRecvList[i].receivePerson,
            receivePhone: this.orderRecvList[i].receivePhone,
            provinceId: this.orderRecvList[i].provinceId,
            cityId: this.orderRecvList[i].cityId,
            countyId: this.orderRecvList[i].countyId,
            detailAddress: this.orderRecvList[i].detailAddress,
            areaData: []
          })
          this.addressInfo.areaData.push(this.addressInfo.provinceId)
          this.addressInfo.areaData.push(this.addressInfo.cityId)
          this.addressInfo.areaData.push(this.addressInfo.countyId)
          flag = true
          break
        }
      }
      if (!flag) {
        this.addressInfo = Object.assign({}, this.addressInfo, {
          receivePerson: '',
          receivePhone: '',
          contactPhone: '',
          provinceId: '',
          cityId: '',
          countyId: '',
          detailAddress: '',
          areaData: {
            provinceId: '',
            cityId: '',
            countyId: ''
          }
        })
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$store.dispatch('getAreaData')
      this.getFreezerInfo()
      this.getQuotaInfo()
      this.queryReceiving()
    },

    // 获取商品信息
    getFreezerInfo () {
      this.freezerInfo = []
      freezerApi.getFreezerInfo(this.$route.query.itemId).then(res => {
        if (res.data.resultCode === '0') {
          this.freezerInfo.push(res.data.resultData.itemInfo)
        }
      })
    },

    // 获取配额信息
    getQuotaInfo () {
      freezerApi.getQuotaInfo(this.$route.query.detailId).then(res => {
        if (res.data.resultCode === '0') {
          this.quotaInfo = res.data.resultData.quotaDTO
        }
      })
    },

    // 售点编码验证
    checkSfaCode () {
      let params = {
        sfaCode: this.sfaInfo.sfaCode
      }
      this.loading = true
      freezerApi.checkSfaCode(params).then(res => {
        this.loading = false
        this.sfaCheck.show = true
        if (res.data.resultCode === '0') {
          this.sfaCheck.success = true
          this.sfaInfo.sfaAddressName = res.data.resultData.sfaAddressName
          this.sfaInfo.sfaAddress = res.data.resultData.sfaAddress
          this.sfaInfo.sfaContactPerson = res.data.resultData.sfaContactPerson
          this.sfaInfo.sfaContactPhone = res.data.resultData.sfaContactPhone
        } else {
          this.sfaCheck.success = false
        }
      }).catch(() => {
        this.loading = false
      })
    },
    sfaInput () {
      this.sfaCheck.show = false
    },

    // 获取十条地址
    queryReceiving () {
      freezerApi.queryReceiving().then(res => {
        if (res.data.resultCode === '0') {
          this.orderRecvList = res.data.resultData.quotaOrderList || []
          this.orderRecvList.forEach(address => {
            const obj = {
              value: address.orderId,
              label: address.receivePerson + ' ' + address.receivePhone + ' ' + address.provinceName + ' ' + address.cityName + ' ' + address.countyName + ' ' + address.detailAddress
            }
            this.addressList.push(obj)
          })
        }
      })
    },

    // 验证地址
    checkAddress () {
      if (!this.addressInfo.receivePerson) {
        this.$message.error('请输入业务员联系人')
        return false
      }
      if (!this.addressInfo.receivePhone) {
        this.$message.error('请输入业务员联系手机')
        return false
      }
      if (!this.addressInfo.receivePhone) {
        this.$message.error('请输入业务员联系手机')
        return false
      }
      if (!this.addressInfo.areaData[0]) {
        this.$message.error('请选择省份')
        return false
      }
      if (!this.addressInfo.areaData[1]) {
        this.$message.error('请选择城市')
        return false
      }
      if (!this.addressInfo.areaData[2]) {
        this.$message.error('请选择区县')
        return false
      }
      if (!this.addressInfo.detailAddress) {
        this.$message.error('请输入详细收货地址')
        return false
      }
      return true
    },

    // 验证售点信息
    checkSfa () {
      if (!this.sfaInfo.sfaCode || !this.sfaCheck.success) {
        this.$message.error('请输入售点编号并验证成功')
        return false
      }
      if (!this.sfaInfo.sfaContactPerson) {
        this.$message.error('请输入售点联系人')
        return false
      }
      if (!this.sfaInfo.sfaContactPhone) {
        this.$message.error('请输入售点联系电话')
        return false
      }
      if (!validateMobile(this.sfaInfo.sfaContactPhone)) {
        this.$message.error('售点联系电话不是正确的手机号码')
        return false
      }
      if (this.addressInfo.receivePhone === this.sfaInfo.sfaContactPhone) {
        this.$message.error('售点电话与业务员电话不能相同，请准确填写售点移动电话。非常感谢！')
        return false
      }
      return true
    },

    // 提交订单
    handleSubmit () {
      if (!this.checkAddress()) {
        return
      }
      if (!this.checkSfa()) {
        return
      }
      this.orderForm.detailList = []
      this.formLoading = true
      this.detailInfo.receivePerson = this.addressInfo.receivePerson
      this.detailInfo.receivePhone = this.addressInfo.receivePhone
      this.detailInfo.provinceId = this.addressInfo.areaData[0]
      this.detailInfo.cityId = this.addressInfo.areaData[1]
      this.detailInfo.countyId = this.addressInfo.areaData[2]
      this.detailInfo.detailAddress = this.addressInfo.detailAddress
      this.detailInfo.sfaCode = this.sfaInfo.sfaCode
      this.detailInfo.sfaContactPerson = this.sfaInfo.sfaContactPerson
      this.detailInfo.sfaContactPhone = this.sfaInfo.sfaContactPhone
      let quotaOrder = {
        quotaId: this.quotaInfo.quotaId,
        itemId: this.freezerInfo[0].itemId,
        itemCode: this.freezerInfo[0].itemCode,
        itemQuantity: 1
      }
      this.orderForm.detailList.push(quotaOrder)
      this.orderForm.quotaOrder = this.detailInfo
      freezerApi.createFreezerOrder(this.orderForm).then(res => {
        this.formLoading = false
        if (res.data.resultCode === '0') {
          this.$router.replace({
            path: '/material/item-order-success',
            query: { orderNumber: res.data.resultData.orderNumber }
          })
        }
      }).catch(() => {
        this.formLoading = false
      })
    },

    getImageUrl (item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item {
  padding: $content-large;
  .el-form-item {
    margin-bottom: $content-middle;
  }
  .sfa-form {
    .el-input {
      width: 345px;
    }
    .btn-blue {
      margin-left: $content-large;
    }
    .validate_tip {
      color: $base-orange;
      margin-left: $content-middle;
    }
  }
  &.price-item {
    padding-top: $content-middle;
    padding-bottom: $content-middle;
    background-color: #ffd6e8;
    text-align: right;
    div + div {
      margin-top: 5px;
    }
    span {
      font-size: 20px;
      color: $base-red;
      font-weight: bold;
    }
  }
}
.submit-btn {
  text-align: center;
  margin-top: $content-large;
}
.order-price {
  background-color: #ffd6e8;
  padding: $content-large;
  height: 130px;
  .price-row {
    padding-top: 18px;
    div {
      margin-bottom: 10px;
      .text-red {
        font-weight: bold;
        color: $base-red;
        font-size: 16px;
      }
    }
  }
  .price-box {
    width: 200px;
    height: 75px;
    box-sizing: border-box;
    padding-top: 14px;
    line-height: 25px;
    text-align: center;
    border-radius: 6px;
    border: 1px dashed rgba(0, 0, 0, 0.15);
  }
}
.order-data-table {
  margin-top: $content-large;
  .item-image {
  width: 72px;
  height: 72px;
  margin: 0 auto;
  border: 1px solid $base-grey;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
